module.exports = __webpack_public_path__ + "media/images/setting-workflow-e090ff14071d6547d2a5d3e91dcdebd2.svg";